import React, { useEffect } from 'react';
import { AdminContentBlock, Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import BlockForm from './BlockForm.jsx';
import AppBarCMS from '../../../../basic/Navigation/AppBarCMS/AppBarCMS';
import { useTranslation } from 'react-i18next';
import { BLOCKS_POSITIONS } from '../../../../../utils/constants/enums.js';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  useGetBlockDetailQuery,
  useSaveBlockMutation,
} from '../../../../../redux/services/blocks';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const BlocksEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  const location = useLocation();

  const navigateTo = location.state?.from?.pathname || routes.cmsBlocks;

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava bloku') + ' - FRI CMS'
      : t('Pridanie bloku') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data: blockDetail, isLoading } = useGetBlockDetailQuery(id, {
    skip: !isEdit,
  });

  const [saveBlock, { isSuccess: isSaveSuccess }] = useSaveBlockMutation();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(navigateTo);
    }
  }, [isSaveSuccess]);

  const initials = {
    label_sk: blockDetail?.label_sk || null,
    content_sk: blockDetail?.content_sk || null,
    position_sk: blockDetail?.position_sk || null,
    label_en: blockDetail?.label_en || null,
    content_en: blockDetail?.content_en || null,
    position_en: blockDetail?.position_en || null,
    generated_content: blockDetail?.generated_content || 0,
  };

  const title = isCreate ? t('Pridanie bloku') : t('Úprava bloku');

  const positionOptions = [
    {
      label: t('Pravý panel'),
      value: BLOCKS_POSITIONS.RIGHT_SIDEBAR,
    },
    {
      label: t('Spodný panel'),
      value: BLOCKS_POSITIONS.FOOTER,
    },
  ];

  return isEdit && isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={title}
        backUrl={routes.cmsBlocks}
        backUrlTooltip={t('Bloky')}
        permissionsBasic={'blocks'}
      />
      <div>
        <AdminContentBlock
          icon="fa fa-sticky-note-o"
          link={routes.cmsBlocks}
          title={title}
        >
          <BlockForm
            positionOptions={positionOptions}
            initials={initials}
            onSubmit={(values) => {
              saveBlock({ data: values, id });
            }}
          />
        </AdminContentBlock>
      </div>
    </>
  );
};

export default BlocksEdit;
